export default __webpack_public_path__ + "static/basePersonajeZonaV-7bb3a69b2db6361d99aaaf073aee8c00.png";